import z from "zod";
import { TenancySchema } from "./tenancyTypes";
import { UserIdSchema } from "./idTypes";

// Role names that can be assigned to a user in a context
export const RoleNameSchema = z.enum(["role.collaborator", "role.owner", "role.reader", ""]);
export type RoleName = z.infer<typeof RoleNameSchema>;

// Focused context represents the current "focused" context for a user
export const FocusedContextSchema = TenancySchema.extend({
  role: RoleNameSchema,
  userId: UserIdSchema,
  switchedAt: z.string(),
});
export type FocusedContext = z.infer<typeof FocusedContextSchema>;

// Request to switch the user's focused context
export const SwitchFocusRequestSchema = TenancySchema;
export type SwitchFocusRequest = z.infer<typeof SwitchFocusRequestSchema>;
